var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.adjective = require("./adjective");
company.descriptor = require("./descriptor");
company.noun = require("./noun");
company.bs_verb = require("./bs_verb");
company.bs_noun = require("./bs_noun");
company.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/company/index.js
// module id = 1227
// module chunks = 0